export const BASE_API_URL = 'https://studentconsent.gis.sport/api';